module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0144.jpg?v=9fdc9011";